/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type { BodyType, ErrorType } from '../../axios';
import { request } from '../../axios';
import type { AppointmentDetailsDto, AppointmentDto, CreateAppointmentDto, GetAppointmentsParams } from '.././model';

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

export const getAppointmentDetails = (id: string, options?: SecondParameter<typeof request>, signal?: AbortSignal) => {
  return request<AppointmentDetailsDto>({ url: `/api/appointments/${id}`, method: 'GET', signal }, options);
};

export const getGetAppointmentDetailsQueryKey = (id: string) => {
  return [`/api/appointments/${id}`] as const;
};

export const getGetAppointmentDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAppointmentDetails>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAppointmentDetailsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppointmentDetails>>> = ({ signal }) =>
    getAppointmentDetails(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAppointmentDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAppointmentDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getAppointmentDetails>>>;
export type GetAppointmentDetailsQueryError = ErrorType<unknown>;

export function useGetAppointmentDetails<
  TData = Awaited<ReturnType<typeof getAppointmentDetails>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentDetails>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getAppointmentDetails>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAppointmentDetails<
  TData = Awaited<ReturnType<typeof getAppointmentDetails>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentDetails>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getAppointmentDetails>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAppointmentDetails<
  TData = Awaited<ReturnType<typeof getAppointmentDetails>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetAppointmentDetails<
  TData = Awaited<ReturnType<typeof getAppointmentDetails>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAppointmentDetailsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAppointmentDetailsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getAppointmentDetails>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppointmentDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAppointmentDetailsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppointmentDetails>>> = ({ signal }) =>
    getAppointmentDetails(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getAppointmentDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAppointmentDetailsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAppointmentDetails>>>;
export type GetAppointmentDetailsSuspenseQueryError = ErrorType<unknown>;

export function useGetAppointmentDetailsSuspense<
  TData = Awaited<ReturnType<typeof getAppointmentDetails>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppointmentDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAppointmentDetailsSuspense<
  TData = Awaited<ReturnType<typeof getAppointmentDetails>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppointmentDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAppointmentDetailsSuspense<
  TData = Awaited<ReturnType<typeof getAppointmentDetails>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppointmentDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetAppointmentDetailsSuspense<
  TData = Awaited<ReturnType<typeof getAppointmentDetails>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppointmentDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAppointmentDetailsSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateAppointment = (
  id: string,
  createAppointmentDto: BodyType<CreateAppointmentDto>,
  options?: SecondParameter<typeof request>,
) => {
  return request<void>(
    {
      url: `/api/appointments/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: createAppointmentDto,
    },
    options,
  );
};

export const getUpdateAppointmentMutationOptions = <
  TData = Awaited<ReturnType<typeof updateAppointment>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<CreateAppointmentDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['updateAppointment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAppointment>>,
    { id: string; data: BodyType<CreateAppointmentDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAppointment(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<CreateAppointmentDto> },
    TContext
  >;
};

export type UpdateAppointmentMutationResult = NonNullable<Awaited<ReturnType<typeof updateAppointment>>>;
export type UpdateAppointmentMutationBody = BodyType<CreateAppointmentDto>;
export type UpdateAppointmentMutationError = ErrorType<unknown>;

export const useUpdateAppointment = <
  TData = Awaited<ReturnType<typeof updateAppointment>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<CreateAppointmentDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<CreateAppointmentDto> }, TContext> => {
  const mutationOptions = getUpdateAppointmentMutationOptions(options);

  return useMutation(mutationOptions);
};
export const deleteAppointment = (id: string, options?: SecondParameter<typeof request>) => {
  return request<void>({ url: `/api/appointments/${id}`, method: 'DELETE' }, options);
};

export const getDeleteAppointmentMutationOptions = <
  TData = Awaited<ReturnType<typeof deleteAppointment>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['deleteAppointment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAppointment>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return deleteAppointment(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { id: string }, TContext>;
};

export type DeleteAppointmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAppointment>>>;

export type DeleteAppointmentMutationError = ErrorType<unknown>;

export const useDeleteAppointment = <
  TData = Awaited<ReturnType<typeof deleteAppointment>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string }, TContext> => {
  const mutationOptions = getDeleteAppointmentMutationOptions(options);

  return useMutation(mutationOptions);
};
export const markAppointmentAsNotAttended = (id: string, options?: SecondParameter<typeof request>) => {
  return request<void>({ url: `/api/appointments/${id}/not-attended`, method: 'PUT' }, options);
};

export const getMarkAppointmentAsNotAttendedMutationOptions = <
  TData = Awaited<ReturnType<typeof markAppointmentAsNotAttended>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['markAppointmentAsNotAttended'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAppointmentAsNotAttended>>, { id: string }> = (
    props,
  ) => {
    const { id } = props ?? {};

    return markAppointmentAsNotAttended(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { id: string }, TContext>;
};

export type MarkAppointmentAsNotAttendedMutationResult = NonNullable<
  Awaited<ReturnType<typeof markAppointmentAsNotAttended>>
>;

export type MarkAppointmentAsNotAttendedMutationError = ErrorType<unknown>;

export const useMarkAppointmentAsNotAttended = <
  TData = Awaited<ReturnType<typeof markAppointmentAsNotAttended>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string }, TContext> => {
  const mutationOptions = getMarkAppointmentAsNotAttendedMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getAppointments = (
  params?: GetAppointmentsParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<AppointmentDto[]>({ url: `/api/appointments`, method: 'GET', params, signal }, options);
};

export const getGetAppointmentsQueryKey = (params?: GetAppointmentsParams) => {
  return [`/api/appointments`, ...(params ? [params] : [])] as const;
};

export const getGetAppointmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAppointments>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAppointmentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointments>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAppointmentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppointments>>> = ({ signal }) =>
    getAppointments(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAppointments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAppointmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getAppointments>>>;
export type GetAppointmentsQueryError = ErrorType<unknown>;

export function useGetAppointments<TData = Awaited<ReturnType<typeof getAppointments>>, TError = ErrorType<unknown>>(
  params: undefined | GetAppointmentsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointments>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getAppointments>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAppointments<TData = Awaited<ReturnType<typeof getAppointments>>, TError = ErrorType<unknown>>(
  params?: GetAppointmentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointments>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getAppointments>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAppointments<TData = Awaited<ReturnType<typeof getAppointments>>, TError = ErrorType<unknown>>(
  params?: GetAppointmentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointments>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetAppointments<TData = Awaited<ReturnType<typeof getAppointments>>, TError = ErrorType<unknown>>(
  params?: GetAppointmentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointments>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAppointmentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAppointmentsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getAppointments>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAppointmentsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppointments>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAppointmentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppointments>>> = ({ signal }) =>
    getAppointments(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getAppointments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAppointmentsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAppointments>>>;
export type GetAppointmentsSuspenseQueryError = ErrorType<unknown>;

export function useGetAppointmentsSuspense<
  TData = Awaited<ReturnType<typeof getAppointments>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetAppointmentsParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppointments>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAppointmentsSuspense<
  TData = Awaited<ReturnType<typeof getAppointments>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAppointmentsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppointments>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAppointmentsSuspense<
  TData = Awaited<ReturnType<typeof getAppointments>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAppointmentsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppointments>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetAppointmentsSuspense<
  TData = Awaited<ReturnType<typeof getAppointments>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAppointmentsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppointments>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAppointmentsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createAppointment = (
  createAppointmentDto: BodyType<CreateAppointmentDto>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<string>(
    {
      url: `/api/appointments`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createAppointmentDto,
      signal,
    },
    options,
  );
};

export const getCreateAppointmentMutationOptions = <
  TData = Awaited<ReturnType<typeof createAppointment>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<CreateAppointmentDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createAppointment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAppointment>>,
    { data: BodyType<CreateAppointmentDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createAppointment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: BodyType<CreateAppointmentDto> },
    TContext
  >;
};

export type CreateAppointmentMutationResult = NonNullable<Awaited<ReturnType<typeof createAppointment>>>;
export type CreateAppointmentMutationBody = BodyType<CreateAppointmentDto>;
export type CreateAppointmentMutationError = ErrorType<unknown>;

export const useCreateAppointment = <
  TData = Awaited<ReturnType<typeof createAppointment>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<CreateAppointmentDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { data: BodyType<CreateAppointmentDto> }, TContext> => {
  const mutationOptions = getCreateAppointmentMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getAppointmentsForPatientWithoutLabOrder = (
  patientId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<AppointmentDto[]>(
    { url: `/api/appointments/patient/${patientId}/without-lab-order`, method: 'GET', signal },
    options,
  );
};

export const getGetAppointmentsForPatientWithoutLabOrderQueryKey = (patientId: string) => {
  return [`/api/appointments/patient/${patientId}/without-lab-order`] as const;
};

export const getGetAppointmentsForPatientWithoutLabOrderQueryOptions = <
  TData = Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAppointmentsForPatientWithoutLabOrderQueryKey(patientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>> = ({ signal }) =>
    getAppointmentsForPatientWithoutLabOrder(patientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!patientId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAppointmentsForPatientWithoutLabOrderQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>
>;
export type GetAppointmentsForPatientWithoutLabOrderQueryError = ErrorType<unknown>;

export function useGetAppointmentsForPatientWithoutLabOrder<
  TData = Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAppointmentsForPatientWithoutLabOrder<
  TData = Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAppointmentsForPatientWithoutLabOrder<
  TData = Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetAppointmentsForPatientWithoutLabOrder<
  TData = Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAppointmentsForPatientWithoutLabOrderQueryOptions(patientId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAppointmentsForPatientWithoutLabOrderSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAppointmentsForPatientWithoutLabOrderQueryKey(patientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>> = ({ signal }) =>
    getAppointmentsForPatientWithoutLabOrder(patientId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAppointmentsForPatientWithoutLabOrderSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>
>;
export type GetAppointmentsForPatientWithoutLabOrderSuspenseQueryError = ErrorType<unknown>;

export function useGetAppointmentsForPatientWithoutLabOrderSuspense<
  TData = Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAppointmentsForPatientWithoutLabOrderSuspense<
  TData = Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAppointmentsForPatientWithoutLabOrderSuspense<
  TData = Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetAppointmentsForPatientWithoutLabOrderSuspense<
  TData = Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppointmentsForPatientWithoutLabOrder>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAppointmentsForPatientWithoutLabOrderSuspenseQueryOptions(patientId, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
